import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';;
import { CmsRoutingModule, routedComponents } from 'src/app/cms/cms-routing.module';
import { CmsModule as ACCmsModule, ACAuthService, ACResourceService, MenuItem, MenuService } from '@appcatalyst/ng-cms-core-lib';
import { GroupsComponent } from './groups/groups.component';
import { InsurancesComponent } from './insurances/insurances.component';
import { SpecialtiesComponent } from './specialties/specialties.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { GroupsService } from './groups/groups.service';
import { first } from 'rxjs/operators';
import { CitiesComponent } from './cities/cities.component';
import { DepartmentsComponent } from './departments/departments.component';
import { RegionsComponent } from './regions/regions.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    CmsRoutingModule,
    ACCmsModule
  ],
  declarations: [
    routedComponents,
    GroupsComponent,
    InsurancesComponent,
    SpecialtiesComponent,
    DashboardComponent,
    CitiesComponent,
    DepartmentsComponent,
    RegionsComponent
  ]
})
export class CmsModule {
  constructor(private gs: GroupsService, menuService: MenuService) {
    // menuService.addMenu('topbar', [
    //   new MenuItem({ title: 'Groups', type: 'dropdown', parentId: 'groups' })
    // ]) 
    // this.gs.getGroups().pipe(
    //   first()
    // ).subscribe(groups => {      
    //   menuService.addDropdownItems('topbar', 'groups', groups.map(group => new MenuItem({ title: group, type: 'button', route: 'groups/'+group })))
    // })
    menuService.addMenu('topbar', [
        new MenuItem({ title: 'Groups', type: 'button', route: 'groups' })
      ]) 
  }
}
